const useIsMobileApp = () => {

  let isApp = false;
  // 1. Detect using userAgentData (Modern Chromium-based, Android WebView)
  const userAgentData = window.navigator.userAgentData;
  userAgentData?.brands.forEach(item => {
    if (item?.brand?.toLowerCase()?.includes("webview")) {
      isApp = true;
    }
  });

  if (isApp) return true;

  const userAgent = window.navigator.userAgent || window.navigator.vendor || window.opera;

  // Android WebView detection (Fallback for browsers without userAgentData)
  const isAndroid = /Android/i.test(userAgent);
  const isAndroidWebView = isAndroid && /wv/i.test(userAgent);

  // iOS WebView detection (WKWebView)
  const isIOSWebView = (/AppleWebKit/i.test(userAgent) && !/Safari/i.test(userAgent) && /Mac OS X/i.test(userAgent));

  return isAndroidWebView || isIOSWebView;
};

export default useIsMobileApp;
